import { StackedLineChartComponent } from './../../../app/stacked-line-chart/stacked-line-chart.component';
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";

import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../app/services/powertrain.service";
import { CommonModule } from "@angular/common";
import { NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import {  MatMenu, MatMenuModule } from "@angular/material/menu";
import { PowertrainAnomalyStatusComponent } from "../powertrain-anomaly-status/powertrain-anomaly-status.component";
import { PowertrainAlertsComponent } from "../powertrain-alerts/powertrain-alerts.component";
import { PowertrainSensorsTableComponent } from "../powertrain-sensors-table/powertrain-sensors-table.component";
import { PowertrainOperationalKpiComponent } from "../powertrain-operational-kpi/powertrain-operational-kpi.component";
import { PowertrainPerformanceComponent } from "../powertrain-performance/powertrain-performance.component";
import { PowerTrainComponent } from "../power-train/power-train.component";
import { CreatePowertrainComponent } from "../powertrain/create-powertrain/create-powertrain.component";
import { PowertrainYtdSavingsComponent } from "../powertrain-ytd-savings/powertrain-ytd-savings.component";
import { PowertrainFlaseClaimsComponent } from "../powertrain-flase-claims/powertrain-flase-claims.component";
import { PowertrainModalComponent } from "../powertrain-modal/powertrain-modal.component";
import { MatTooltip, MatTooltipModule } from "@angular/material/tooltip";
import { PowertrainHealthbarComponent } from "../powertrain-healthbar/powertrain-healthbar.component";
import { MatIcon } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
@Component({
  selector: "app-device-detail-nxt-v2",
  templateUrl: "./device-detail-nxt-v2.component.html",
  styleUrls: ["./device-detail-nxt-v2.component.scss"],
  standalone:true,
  imports:[StackedLineChartComponent, MatIcon, MatButtonModule, CommonModule,NgbNavModule,MatMenuModule,MatMenu,
    PowertrainAnomalyStatusComponent,PowertrainAlertsComponent,PowertrainSensorsTableComponent,PowertrainOperationalKpiComponent,
    PowertrainPerformanceComponent,PowerTrainComponent,PowertrainYtdSavingsComponent,
    PowertrainFlaseClaimsComponent,PowertrainModalComponent,MatTooltipModule,PowertrainHealthbarComponent]
})
export class DeviceDetailNxtV2Component implements OnInit, OnDestroy {
  sensorpositionUrl = BaseUrlConstantsService.POWERTRAIN_API_SENSORS_POSITION;
  deleteUrl = BaseUrlConstantsService.POWERTRAIN_DELETE_API;
  siteAppUrl = BaseUrlConstantsService.POWERTRAIN_SITES_APP;
  showTrendsChart: boolean = false;
  public production = BaseUrlConstantsService.PRODUCTION_KEY;

  subsystem_id: number | string = null;
  client_id: number | string = null;
  deviceSerialNo: any;
  assetIds: string[] = [];
  inventory_ids: string[] = [];
  mac_addresses: string[] = [];
  serial_numbers: string[] = [];
  assetInventoryIds: any = [];
  graphType: number[] = [];
  sensorTabeData: any = [];
  masterMacaddress: string = "";
  powertrain_name: string = "";
  company_name: string = localStorage.getItem("company_name");
  loader = true;
  site_id: number | string = null;
  application_id: number | string = null;
  lastFileProcessedTime: string = "";
  today = "";
  showModal = false;
  showPlateDetailsModal = false;
  showDeleteLoader = false;
  commission_date:string;
  uuid: string = '';
  overall_live_status:number|string=null;

  // SUBSCRIPTIONS
  lastFileProcessedSubscription = new Subscription();
  editReturnSubscription = new Subscription();
  subscription: Subscription;
  type1Devices: any =[];
  type2Devices: any =[];
  type3Devices: any=[];
  type4Devices: any=[];

  constructor(
    private route: ActivatedRoute,
    private service: PowerTrainService,
    private router: Router
  ) {
    let { queryParams } = this.route.snapshot;
    if (queryParams["isEditReturn"]) {
      this.editReturnSubscription=this.service.powertrainEditDataObs.subscribe((data) => {
        const { id, client_id, powertrainName, site_id, application_id } = data;
        this.subsystem_id = id;
        this.client_id = client_id;
        this.powertrain_name = powertrainName;
        this.site_id = site_id;
        this.application_id = application_id;
      });
    } else {
      this.subsystem_id = queryParams["subsystem_id"];
      this.client_id = queryParams["client_id"];
      this.powertrain_name = queryParams["subsystem_name"];
      this.site_id = queryParams["site_id"];
      this.application_id = queryParams["application_id"];
      this.commission_date=queryParams["commission_date"]
      this.uuid = queryParams["uuid"];
      this.overall_live_status=queryParams['overall_live_status']
      this.service.updateoldDashboardParams(queryParams["oldDashboardParams"]);
    }
  }
  processQueryParams(queryParams){
    if (queryParams["isEditReturn"]) {
      this.editReturnSubscription=this.service.powertrainEditDataObs.subscribe((data) => {
        console.log(data,'processquer')
        const { id, client_id, powertrainName, site_id, application_id } = data;
        this.subsystem_id = id;
        this.client_id = client_id;
        this.powertrain_name = powertrainName;
        this.site_id = site_id;
        this.application_id = application_id;
      });
    } else {
      this.subsystem_id = queryParams["subsystem_id"];
      this.client_id = queryParams["client_id"];
      this.powertrain_name = queryParams["subsystem_name"];
      this.site_id = queryParams["site_id"];
      this.application_id = queryParams["application_id"];
      this.service.updateoldDashboardParams(queryParams["oldDashboardParams"]);
    }
  }

  serviceBookOpen() {
    throw new Error("Method not implemented.");
  }
  isOutOfService: any;
  getDeviceInfo() {
    throw new Error("Method not implemented.");
  }

  public breadcrumbsArray: any = [
    {
      page_ref: "device-reports",
      page_title: "All Assets",
    },
    {
      page_ref: "#",
      page_title: "Monitoring",
    },
  ];
  connectivityType;
  userRoll = "CLIENT";

  async ngOnInit() {
    await this.waitForMessage()
    this.fetchSensorsPositions();
    this.fetchSiteAppname();
    this.utcTime();
    this.lastFileProcessedSubscription =
      this.service.lastFileProcessedObs.subscribe((time) => {
        this.lastFileProcessedTime = time;
      });
      this.subscription = this.service.oldDashboardParamsObs.subscribe(
  (data) => {
    let parsedData = JSON.parse(data);
    const devicePositions = parsedData[0]?.connected_sensors || [];
    // Initialize variables for each master_type

    // Separate devices based on master_type
    devicePositions.forEach(dp => {
      const masterType = Number(dp.master_type);
      console.log(masterType,'mastertype')
      const device = { asset_id: dp.id, mac_address: dp.mac_address, master_type : masterType };
      switch (masterType) {
        case 1:
          this.type1Devices.push(device);
          break;
        case 2:
          this.type2Devices.push(device);
          break;
        case 3:
          this.type3Devices.push(device);
          break;
        case 4:
          this.type4Devices.push(device);
          break;
      }
    });

    // Log results
    console.log('Type 1 devices:', this.type1Devices);
    console.log('Type 2 devices:', this.type2Devices);
    console.log('Type 3 devices:', this.type3Devices);
    console.log('Type 4 devices:', this.type4Devices);
  }
);

  }
  ngOnDestroy() {
    // window.removeEventListener('message', this.msgHandler);
    this.lastFileProcessedSubscription.unsubscribe();
    this.editReturnSubscription.unsubscribe();
  }

  fetchSensorsPositions() {
    this.assetIds=[];
    this.inventory_ids=[];
    this.mac_addresses=[];
    this.serial_numbers=[];
    this.sensorTabeData=[];
    this.assetInventoryIds=[];
    this.graphType = [0, 1, 2, 3, 4, 5];

    this.loader = true;
    this.service
      // .fetchSensorpositions(
      //   "http://localhost:4358/monitoring/powertrain/sensor-postions/" +
      //     this.subsystem_id
      // )
      .fetchSensorpositions(this.sensorpositionUrl + this.subsystem_id)
      .then((res: any) => {
        const { device_position } = res.data;
        device_position.forEach((sensor) => {
          if (sensor.sensor_number == 0) {
            this.masterMacaddress = sensor.mac_address;
          }
          this.assetIds.push(sensor.asset_id);
          this.inventory_ids.push(sensor.device_id);
          this.mac_addresses.push(sensor.mac_address);
          this.serial_numbers.push(sensor.motor_serial);
          this.sensorTabeData.push({
            asset_id: sensor.asset_id,
            inventory_id: sensor.device_id,
            color: sensor.color,
            sensor_no: sensor.sensor_number,
            loader: true,
            sensorMarker:sensor.sensorMarker,
            sensorDNames:sensor.sensorDNames,

          });
          this.assetInventoryIds.push({
            asset_id: sensor.asset_id,
            inventory_id: sensor.device_id,
            mac_address: sensor.mac_address,
            sensor_no: sensor.sensor_number,
            sensor_marker: sensor.sensorMarker,
            sensorDNames:sensor.sensorDNames,
            assetType: sensor.assetType,
            clientId: this.client_id,
            subSystemId: this.subsystem_id,
          });
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loader = false;
      });
  }

  fetchSiteAppname() {
    this.service
      .fetchSiteAppname(
        `${this.siteAppUrl}${this.site_id}/${this.application_id}/${this.client_id}`
      )
      .then((data) => {
        this.site_id = data[0].site_name;
        this.application_id = data[0].app_name;
      })
      .catch((err) => {
        console.log("Error fetching site app name");
      });
  }

  async goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        tabName: "tab-1",
        pageRef:'',
        tab1:true,
        powertrain: true,
      },
    };
    let role=localStorage.getItem("role");
    if(role=='ADMIN'){
      this.router.navigate(['device-report-new'], navigationExtras);
    }else{
      this.router.navigate([name], navigationExtras);
    }

  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  openDeleteModal() {
    this.showModal = true;
  }

  onDeleteModalResponse(data) {
    if (data.deleted) {
      this.deletePowertrain();
    } else {
      this.showModal = false;
    }
  }

  deletePowertrain() {
    this.showDeleteLoader = true;
    this.service
      .deletePowertrain(this.deleteUrl + this.subsystem_id)
      .then((data) => {
        this.showModal = false;
        this.router.navigate(["/device-reports"]);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.showDeleteLoader = false;
      });
  }

  openPlateDetailsModal(){
    this.showPlateDetailsModal=true
  }
  closePlateDetailsModal(event:any){
    this.showPlateDetailsModal=false
    if(event){
      this.fetchSensorsPositions();
    }
  }

  toggleTrends() {
    this.showTrendsChart = !this.showTrendsChart;
  }

  private waitForMessage(): Promise<void> {
    const assocId = localStorage.getItem('associated_clientid');
    const userId = localStorage.getItem('user_id');
    const adminId = localStorage.getItem('admin_client_id');


    return new Promise((resolve) => {
      if (assocId == '9000' || userId == '9000' || adminId == '9000') {

        window.opener?.postMessage({ type: 'ready' }, window.location.origin);

      const messageHandler = (event: MessageEvent) => {
        if (event.origin !== window.location.origin || event.data?.type !== 'init') {
          return;
        }
        const qp = event.data.payload?.data.queryParams;
        // console.log(qp);
        if (qp) {
          this.processQueryParams(qp);
        }
        window.removeEventListener('message', messageHandler);
        clearTimeout(timeoutId);
        resolve();
      };
      const timeoutId = setTimeout(() => {
        window.removeEventListener('message', messageHandler);
        // this.router.navigate(['/home']);
        resolve();
      }, 3500);
      window.addEventListener('message', messageHandler, false);

      }else{
        resolve()
        return
      }
      });
  }


}
